/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

// Separate time and area blocks

/*
* Area block
*/

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements, getAllowedOutputs } from '../block_compatibility_checks';
import { AreaService } from '@/services/area.service';
import { getCurrentSat } from '../dataset';
import { areaChange } from '../helper_functions';

Blockly.Blocks['input_area_selection'] = {
    init: function () {
        let areas = AreaService.getAreas();
        this.appendDummyInput('area_input')
            .appendField("Area: ")
            .appendField(new Blockly.FieldDropdown(areas), "area");
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('boundaries'));
        this.setInputsInline(false);
        this.setPreviousStatement(true, 'boundaries');
        this.setNextStatement(true, getAllowedOutputs('boundaries'));
        this.setStyle('input');
        this.setTooltip(Blockly.Msg.BOUNDARIES_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.prevp = null
        this.setOnChange(() => {

            if (this.getSurroundParent() !== this.prevp && this.getSurroundParent() !== null) {
                this.removeInput('do')
                let sat = getCurrentSat(this)
                let next = 'boundaries_other'
                if (['l8', 'l7', 'l4', 'l5', 's2', 'SAR', 'PALSAR'].includes(sat)) { next = 'boundaries' }
                this.appendStatementInput("do")
                    .setCheck(getAllowedStatements(next));
                this.prevp = this.getSurroundParent()
            }

        });

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "area_input", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },

};